<template>
  <div class="absolute top-0 left-0 z-[50] w-screen h-screen">
    <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-85"></div>
    <div class="fixed inset-0 z-10 w-screen max-h-[80%] max-w-[80%] m-auto">
      <div class="flex flex-col h-full p-1 pt-6 sm:p-10">
        <div
          class="relative flex flex-col w-full h-full p-4 overflow-hidden bg-white rounded-lg shadow-xl">
          <div class="sticky flex justify-between p-3 bg-cyan-light">
            <h1 class="font-medium text-theme-700">
              {{ modalTitle }}
            </h1>
            <button @click="$emit('cancel')">
              <Icon icon="mdi-close" class="w-4 h-4 ml-2 text-theme-700"></Icon>
            </button>
          </div>
          <div class="flex-1 h-full overflow-auto max-h-[60vh]">
            <table class="w-full overflow-auto border-separate table-auto">
              <tbody class="text-xs">
                <tr
                  v-for="(result, index) in searchResults"
                  :key="index"
                  class="border border-transparent odd:bg-white even:bg-slate-100 flex flex-col flex-wrap p-2.5 font-medium rounded-md sm:p-0 hover:bg-cyan-light cursor-pointer"
                  @click="$emit('select', result)">
                  <td class="p-2.5">
                    <div class="flex justify-between">
                      <div>
                        <div v-if="result.alterCode">
                          {{ result.alterCode.name }}
                        </div>
                        <div class="flex gap-1">
                          <div class="font-light text-[10px]" v-if="result.alterCode">
                            {{ result.alterCode.code }}
                          </div>
                          <p class="font-light text-[10px]" v-if="result.alterCode">-</p>
                          <div class="font-light text-[10px]" v-if="result.measurementUnit">
                            {{ result.measurementUnit.code }}
                          </div>
                        </div>
                      </div>
                      <button @click.stop.prevent="$emit('showModal', result)">
                        <IconInfo
                          class="w-3.5 h-3.5 rounded-full text-theme-500 bg-cyan-light"></IconInfo>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <BaseButton
            outline
            class="flex items-center justify-center w-full h-8 px-3 py-2 my-2 text-sm font-medium capitalize border-0 rounded-md shadow-sm sm:ml-3 sm:w-auto bg-cyan-light"
            @click="$emit('cancel')"
            >{{ $t('common.actions.cancel') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BaseButton from '@/components/common/BaseButton.vue';
import type { MaterialAlterCode } from '@/types/Materials';
import { useI18n } from 'vue-i18n';
import IconInfo from '@/assets/icons/IconInfo.vue';
import { Icon } from '@iconify/vue/dist/iconify.js';

const { t: $t } = useI18n();

interface ModalProps {
  searchResults: Partial<MaterialAlterCode>[];
}

const props = defineProps<ModalProps>();

defineEmits(['select', 'cancel', 'showModal']);

const modalTitle = computed(() => {
  if (props.searchResults.length) return `Found ${props.searchResults.length} results`;
  return 'No results found';
});
</script>
